<template>
    <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
        <i class="fal fa-spinner fa-spin" /> Quality Control Loading...
    </div>
    <div v-else class="animated fadeIn">
        <basic-heading title="Quality Control">
            <template #right-content>
                <header-button-group :button_config="button_config"></header-button-group>
            </template>
        </basic-heading>
        <div class="mt-3">
            <quality-control-card :qualityControl="this_quality_control"></quality-control-card>
            <div class="mt-3">
                <quality-control-related-list :task="this_quality_control.schedulable_task" :testPackageId="this_quality_control.test_package_id" />
            </div>
        </div>
    </div>
</template>
<script>
import BasicHeading from '@/components/shared/BasicHeading.vue';
import BadgeBatch from "@/components/shared/BadgeBatch";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import QualityControlCard from '@/components/lab/qualitycontrol/QualityControlCard';
import QualityControlRelatedList from '@/components/lab/qualitycontrol/QualityControlRelatedList';
import { getCollection } from "@/shared/fetch-utils";

export default {
    name: "QualityControlDetail",
    components: {
        BasicHeading,
        QualityControlCard,
        BadgeBatch,
        HeaderButtonGroup,
        QualityControlRelatedList,
    },
    data() {
        return {
            loading: true,
            quality_control_id: this.$route.params.quality_control_id || null,
            this_quality_control: null,
        };
    },
    computed: {
        button_config() {
            return {
                buttons: [
                    {
                        icon: "fa-search",
                        linkto: `/quality-control/${this.quality_control_id}/audit-trail`,
                        title: "Quality Control list",
                        variant: "dark",
                    },
                    {
                        icon: "fa-list",
                        linkto: "/quality-control",
                        title: "Quality Control list"
                    },
                    {
                        icon: "fa-pencil",
                        linkto: `/quality-control/${this.quality_control_id}/edit`,
                        title: "Edit Quality Control",
                        variant: "warning"
                    },
                ],
            };
        },
    },
    methods: {
        async init() {
            const collection = await getCollection({
                collection_type: "quality_control",
                filters: [
                    {
                        logic: "filterIn",
                        field: "id",
                        value: this.quality_control_id
                    },
                ],
            });

            this.this_quality_control = {...collection.models[0].attributes};

            this.loading = false;
        }
    },
    created() {
        this.init();
    }
};
</script>
